import React from "react";
import styled from "styled-components";
import Box from "react-raster";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import Container from "../Container";
import { H2, Copy, Eyebrow } from "../Typography";

const Position = styled(Eyebrow)`
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid ${({ theme }) => theme.colours.lightGrey};
`;

const PersonContainer = styled.a`
  display: block;
  text-decoration: none;

  @media (${({ theme }) => theme.mq.m}) {
    padding: 0 24px;
    > .gatsby-plugin-image-wrapper {
      transform: scale(1);
      transform-origin: bottom;
      transition: transform 0.1s ease-in-out;
    }

    &:hover {
      > .gatsby-plugin-image-wrapper {
        transform: scale(1.02);
        transition: transform 0.1s ease-in-out;
      }
    }
  }
`;

const Image = styled(GatsbyImage)`
  margin-bottom: 20px;
`;

function Leadership({ title, people }) {
  return (
    <Container>
      <Box cols={[6, 4, 4]} marginBottom={1}>
        <H2>{title}</H2>
      </Box>
      {people.map((person) => (
        <Box cols={[6, 4, 4]} marginBottom={1} key={person.id}>
          <PersonContainer
            href={person.url}
            title={person.name}
            target="_blank"
          >
            <Image image={getImage(person.image)} alt={person.name} />
            <Copy isMarkdown={false} medium>
              {person.name}
            </Copy>
            <Position decorated={false} colour="lightGrey">
              {person.position}
            </Position>
          </PersonContainer>
        </Box>
      ))}
    </Container>
  );
}

export default Leadership;
